import React, { useEffect, useState } from "react";
import Vimeo from "@u-wave/react-vimeo";
import { useBreakpoint } from "gatsby-plugin-breakpoints";
import { isBrowserHelper } from "../../helpers";
import "./BgVideo.scss";
import AnimatedIcon from "./AnimatedIcon";

type Props = {};

export const BgVideo = () => {
  const { sm: isMobile } = useBreakpoint();

  const [windowSize, setWindowSize] = useState<number | undefined>(undefined);

  const bgVideoUrl = isMobile
    ? "https://player.vimeo.com/video/775200925?h=04eef11c2b"
    : "https://player.vimeo.com/video/769059909?h=cde1e67b56";

  const [videoLoading, setVideoLoading] = useState(true);

  const isBrowser = isBrowserHelper();

  useEffect(() => {
    const handleResize = () => {
      if (isBrowser) {
        setWindowSize(window.innerWidth);
      }
    };

    if (isBrowser) {
      window.addEventListener("resize", handleResize);
      handleResize();
    }

    return () => {
      if (isBrowser) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, [isBrowser]);

  if (!isBrowser) {
    return null;
  }

  return (
    <div className="bg-video-container">
      {videoLoading && <AnimatedIcon />}

      <div className="background-video">
        {windowSize && (
          // @ts-ignore
          <Vimeo
            video={bgVideoUrl}
            background
            width={windowSize}
            loop
            dnt
            onPlay={() => setVideoLoading(false)}
          />
        )}
      </div>
    </div>
  );
};
